import React, {useEffect, useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const IpadCoverCasoClinico4 = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const {userId, casoClinico, gameId } = location.state || {};
    const [playerField, setPlayerField] = useState('');

    useEffect(() => {
        // Determina quale campo aggiornare per il giocatore
        const fetchPlayerField = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-players`, { params: { gameId } });
                const { fkidplayer1, fkidplayer2 } = response.data;

                // Determina se il giocatore corrente è player1 o player2
                if (userId === fkidplayer1) {
                    setPlayerField('monitor_player1');
                } else if (userId === fkidplayer2) {
                    setPlayerField('monitor_player2');
                } else {
                    console.error("Errore: userId non corrisponde a nessun giocatore.");
                }
            } catch (error) {
                console.error("Errore nel recupero delle informazioni dei giocatori:", error);
            }
        };

        fetchPlayerField();
    }, [gameId, userId]);


    // Aggiorna lo stato del giocatore nel database
    const updatePlayerState = async (nextState) => {
        if (!playerField) return;

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state-bis`, {
                gameId,
                playerField,
                state: nextState
            });
            console.log(`Stato aggiornato per ${playerField}: ${nextState}`);
        } catch (error) {
            console.error("Errore nell'aggiornamento dello stato del monitor:", error);
        }
    };


    useEffect(() => {
        if (playerField) {
            updatePlayerState('anamnesi4');
        }
    }, [playerField, gameId]);



    useEffect(() => {
        // OLD: Invia una richiesta al backend per aggiornare lo stato del monitor
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state`, { gameId, monitor: 'anamnesi4' })
            .then((response) => {
                console.log("Stato del monitor aggiornato:", response.data);
            })
            .catch((error) => {
                console.error("Errore nell'aggiornamento dello stato del monitor:", error);
            });
    }, [casoClinico, gameId]);


    const startCase = () => {
        navigate('/ipad/domanda4', { state: { userId, casoClinico, gameId } });
    };

    return (
        <div className="ipad_cover flex flex-col w-full h-full  items-center justify-center relative bg-fixed" onClick={startCase}>

            {/* Titolo dinamico del Caso Clinico */}
            <h1 className="text-[80px] font-bold text-white text-center top-[80px] relative" >CASO <br/>CLINICO {casoClinico}</h1>


            {/* Pulsante per iniziare il caso clinico */}
            <div className="relative top-[100px]" >
            <button
               
                className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition duration-300"
            >
                Tap per continuare
            </button>
            </div>
        </div>
    );
};

export default IpadCoverCasoClinico4;
